export function getCurrentUser() {
    var _a, _b;
    const currentUserJson = (_b = (_a = document.getElementById("current-user")) === null || _a === void 0 ? void 0 : _a.textContent) !== null && _b !== void 0 ? _b : "{}";
    return JSON.parse(currentUserJson);
}
